import networkService from '../Network/NetworkManager';
import APPURL from '../Constants/URLConstants';

let creditsRequest = null;

const unwrap = response => response?.data?.data ?? response?.data ?? response ?? {};

const firstValue = (object, keys) => {
  for (const key of keys) {
    const value = object?.[key];
    if (value !== undefined && value !== null && value !== '') return value;
  }
  return null;
};

const request = path => networkService.networkCall(path, 'GET', '');

const normalizeBalance = response => {
  const data = unwrap(response);
  return {
    available: firstValue(data, [
      'total_available_credits',
      'available_credits',
      'credits_available',
      'credits',
      'balance',
    ]),
    granted: firstValue(data, ['total_credits', 'total_granted_credits', 'credits_granted']),
    used: firstValue(data, ['total_used', 'total_used_credits', 'used_credits']),
    expired: firstValue(data, ['total_expired', 'total_expired_credits', 'expired_credits']),
    limit: firstValue(data, ['credit_limit', 'credits_limit', 'monthly_limit', 'limit', 'cap']),
    resetAt: firstValue(data, ['reset_at', 'resets_at', 'next_reset_at']),
    raw: data,
  };
};

const normalizeSummary = response => {
  const data = unwrap(response);
  return {
    available: firstValue(data, ['total_available_credits', 'available_credits', 'credits_available']),
    granted: firstValue(data, ['total_granted', 'total_granted_credits', 'credits_granted']),
    used: firstValue(data, ['total_used', 'total_used_credits', 'used_credits']),
    expired: firstValue(data, ['total_expired', 'total_expired_credits', 'expired_credits']),
    limit: firstValue(data, ['credit_limit', 'credits_limit', 'monthly_limit', 'limit', 'cap']),
    resetAt: firstValue(data, ['reset_at', 'resets_at', 'next_reset_at']),
    period: firstValue(data, ['period', 'period_start', 'window']),
    raw: data,
  };
};

export const loadCreditsOverview = () => {
  if (!creditsRequest) {
    creditsRequest = Promise.allSettled([
      request(APPURL.URLPaths.aiCreditsBalance),
      request(APPURL.URLPaths.aiCreditsSummary),
    ])
      .then(([balanceResult, summaryResult]) => {
        const balanceResponse = balanceResult.status === 'fulfilled' ? balanceResult.value : null;
        const summaryResponse = summaryResult.status === 'fulfilled' ? summaryResult.value : null;
        return {
          balance: balanceResponse?.status === true ? normalizeBalance(balanceResponse) : null,
          summary: summaryResponse?.status === true ? normalizeSummary(summaryResponse) : null,
          errors: [balanceResult, summaryResult]
            .filter(result => result.status === 'rejected' || result.value?.status !== true)
            .map(result => result.status === 'rejected' ? result.reason : result.value),
        };
      })
      .then(result => {
        creditsRequest = null;
        return result;
      }, error => {
        creditsRequest = null;
        throw error;
      });
  }

  return creditsRequest;
};

export const resetCreditsOverview = () => {
  creditsRequest = null;
};

export default {
  loadCreditsOverview,
  resetCreditsOverview,
};
